export {FilterConnected as Filter} from './Filter.connect';
